/**
 * Feedback Frontend React App
 * 
 * This renders into the feedback panel within the Release Hub block
 */
import { render } from '@wordpress/element';
import FeedbackApp from './FeedbackApp';
import './styles/index.css';

// Wait for DOM and config
document.addEventListener('DOMContentLoaded', () => {
    // Check for frontend config (from Release Hub block)
    const frontendConfig = window.chaFeedbackFrontend || {};
    
    // Find the feedback container
    const container = document.getElementById('cha-feedback-app');
    if (!container) {
        // No container found, silently skip
        return;
    }

    // Get product ID from data attribute or config
    const productId = container.dataset.productId 
        ? parseInt(container.dataset.productId, 10) 
        : (frontendConfig.productId || 0);
    
    render(
        <FeedbackApp 
            productId={productId}
            categories={frontendConfig.categories || {}}
            statuses={frontendConfig.statuses || {}}
            restUrl={frontendConfig.restUrl || '/wp-json/changeloger/v1/feedback'}
            nonce={frontendConfig.nonce || ''}
            isLoggedIn={frontendConfig.isLoggedIn === '1' || false}
            isPremium={frontendConfig.isPremium === '1' || false}
            currentUser={frontendConfig.user || null}
            // Pagination
            perPage={parseInt(frontendConfig.perPage, 10) || 10}
            // Feedback settings
            allowComments={frontendConfig.allowComments === '1' || false}
            // Voting settings
            enableDownvoting={frontendConfig.enableDownvoting === '1' || false}
            allowGuestVoting={frontendConfig.allowGuestVoting === '1' || false}
            // Auth settings
            enableGoogleLogin={frontendConfig.enableGoogleLogin === '1' || false}
            enableEmailSignup={frontendConfig.enableEmailSignup === '1' || false}
            loginUrl={frontendConfig.loginUrl || ''}
            registerUrl={frontendConfig.registerUrl || ''}
            ajaxUrl={frontendConfig.ajaxUrl || ''}
        />,
        container
    );
});
